import React from 'react';
import EmojiText from 'design-system/EmojiText';
import CategoryBadge from 'features/invest/components/CategoryBadge';
const SuggestionListItem = ({ suggestion, didUserAlterName, suggestedName, onPress, }) => {
    const { name, emoji } = suggestion;
    const Icon = emoji ? () => <EmojiText>{emoji}</EmojiText> : undefined;
    return (<CategoryBadge key={name} name={name} Icon={Icon} onPress={onPress(name, emoji)} selected={name === suggestedName && !didUserAlterName}/>);
};
export default SuggestionListItem;
